import { render, staticRenderFns } from "./ManageLossReasons.vue?vue&type=template&id=24a8edc3&scoped=true&"
import script from "./ManageLossReasons.vue?vue&type=script&lang=js&"
export * from "./ManageLossReasons.vue?vue&type=script&lang=js&"
import style0 from "./ManageLossReasons.vue?vue&type=style&index=0&id=24a8edc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a8edc3",
  null
  
)

export default component.exports